import type { AddedCircuitRows } from "./types";

/**
 * The BoQ row a created run needs to be READ, ordered, searched and picked as a
 * target. Geometry alone puts a run on the plan with no card in the list, and a
 * run with no card cannot be moved onto, priced or struck.
 *
 * `board` carries the marker LABEL, which is what `CircuitCard` matches a feed
 * point on — the name it prints comes from the board roster, so renaming the
 * board renames the row without this being rewritten.
 */
export const addedCircuitRows: AddedCircuitRows = ({
  circuits,
  lengthsByCircuit,
}) =>
  Object.entries(circuits).map(([circuitId, circuit]) => ({
    item: circuitId,
    // The schedule's own words when he took the way off it; otherwise the id —
    // which the card then prints once, in the id column, and not twice.
    text: circuit.description?.trim() || circuit.key,
    quantity: lengthsByCircuit?.[circuitId] ?? 0,
    unit: "m",
    cable_type: circuit.cableType,
    board: circuit.sourceLabel,
    circuit: circuitId,
    ...(circuit.system ? { system: circuit.system } : {}),
  }));
